import {
  Input,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Select,
  YearTable,
  MonthTable,
  DateTable,
  TimeSpinner,
  DatePicker,
  DatePanel,
  TimePanel,
  Switch,
  Cascader,
  Autocomplete,
  Suggestions,
  Button,
  Upload,
  Popup
} from '@bag'

function formItem(opt) {
  const { label, size, block, class: cls } = opt
  if (!block) return { outer: null, inner: null }
  let outer, inner
  if (block === 'unit') {
    outer = $(`<div class="form-item__content ${cls || ''}"></div>`)
    inner = outer
  } else {
    outer = $(`
    <div class="form-item ${cls || ''}">
      <label class="form-item__label" style="width: 120px;">${label}</label>
      <div class="form-item__content" style="margin-left: 120px;"></div>
    </div>`)
    inner = outer.find('.form-item__content')
    if (label === undefined) {
      outer.find('label').remove()
      inner.css({ 'margin-left': 0 })
    }
    if (block === 'widget') {
      outer.addClass('form-widget')
    }
  }
  outer.removeClass('form-item--*')
  switch (size) {
    case 'medium':
      outer.addClass('form-item--medium')
      break
    case 'small':
      outer.addClass('form-item--small')
      break
    case 'mini':
      outer.addClass('form-item--mini')
      break
  }
  return { outer, inner }
}

function section(opt) {
  const { class: clazz, title } = opt
  return $(`<div class="col-sm-12 ${clazz || ''} lt-section-label">${title}</div>`)
}

const util = {
  autocomplete(opt) {
    return new Autocomplete(opt)
  },
  text(opt) {
    return new Input(opt)
  },
  hidden(opt) {
    return new Input(opt)
  },
  textarea(opt) {
    return new Input(opt)
  },
  radio(opt) {
    return new RadioGroup(opt)
  },
  checkbox(opt) {
    return new CheckboxGroup(opt)
  },
  select(opt, mod) {
    return new Select(opt)
  },
  switch(opt) {
    return new Switch(opt)
  },
  cascader(opt, mod) {
    return new Cascader(opt)
  },
  timepicker(opt, mod) {
    return new DatePicker(opt)
  },
  datepicker(opt, mod) {
    return new DatePicker(opt)
  },
  datetimepicker(opt, mod) {
    return new DatePicker(opt)
  },
  upload(opt) {
    return new Upload(opt)
  },
  inputnumber(opt) {
    // return new Textarea(opt)
  },
  popup(opt) {
    return new Popup(opt)
  },
  transfer(opt) {
    // return new Textarea(opt)
  },
  headimage(opt) {
    // return new Textarea(opt)
  },
  formItem(opt) {
    return formItem(opt)
  },
  section(opt) {
    return section(opt)
  },
  button(opt) {
    return new Button(opt)
  }
}

export default util
